import auth from './auth'
import grade from './grade'

const api = { auth, grade}

export default api
